export default {
    "shipping_wine_info": "預托運酒資訊",
    "add_wine": "點擊新增想要取貨的酒吧！",
    "back_to_wine_list": "返回藏酒列表",
    "shipping_method_and_cost": "運送方式及費用試算",
    "shipping_method": "運送方式",
    "delivery_loaction": "送貨地點",
    "specified_time": "指定時間",
    "pick_up_time": "取貨時間",
    "pick_up_location": "取貨地點",
    "remark": "備註",
    "cost_calc": "費用試算",
    "select_pick_up_date": "請選擇取貨日",
    "by_self_pick_up": "自取",
    "by_delivery_1": "物流運送至指定地點",
    "add_more": "新增更多",
    "choose_from_history": "從歷史訂單選擇",
    "shipping_fee": "運費",
    "business_hours": "營業時間",
    "select_wines": "選擇要托運的酒款",
    "recently_added": "最近加入",
    "highest_price": "價格最高",
    "sort": "排序按照",
    "select_all": "全選",
    "arrival_time_not_specify": "不指定",
    "arrival_time_morning": "13時前",
    "arrival_time_afternoon": "14-18時",
    "arrival_time_night": "18時-21時",
    "shipping_info_confirm": "托運資訊確認",
    "selected": "已選擇",
    "go_shipping": "我要托運",
    "order_address": "訂單記錄地址",
    "next_step_confirm": "下一步",
    "back": "回前頁",
    "submit": "送出托運單",
    "shipping_items": "托運項目",
    "shipping_type": "取貨方式",
    "home_delivery": "物流運送至指定地點",
    "store_pick_up": "自取",
    "picker_name": "取件人姓名",
    "picker_tel": "取件人電話",
    "shipping_address": "取貨地址",
    "pickup_date": "取貨日期",
    "pickup_time": "指定時間",
    "pickup_date_time": "取貨日期/時間",
    "urgent_tip": "急件說明",
    "today_urgent": "當日特急件",
    "next_day_urgent": "隔日急件",
    "ordinary": "一般件",
    "price_calc": "價格試算",
    "order_confirm": "訂單資訊確認",
    "receipt_info": "發票資訊",
    "receipt_info_tip": "託運發票將隨您的愛酒一並附上。",
    "receipt_title": "發票抬頭",
    "tax_id": "統一編號",
    "fee_info": "費用統計",
    "shipping_detail": "託運項目",
    "service_fee": "服務費用",
    "service_fee_tip": "服務費用說明",
    "logistics_cost": "物流費用",
    "logistics_cost_tip": "運費說明",
    "credit_card": "信用卡",
    "total": "小計",
    "coupon": "優惠券",
    "coupon_bonus": "優惠券折抵",
    "not_use_coupon": "不使用優惠券",
    "coupon_expiry_date": "到期日",
    "total_fee": "總金額",
    "currency_unit": "元",
    "two_line_receipt": "二聯式紙本發票",
    "three_line_receipt": "三聯式紙本發票",
    "shipping_info": "物流資訊"
}